import React from 'react';
import { IconCircleCheck, IconCircleX } from '@tabler/icons-react';
import { COLORS } from '@app/constants';
import { Text, View } from '@/styles/reactnative';
import { useTranslation } from 'react-i18next';
import { useMyProfile } from '../../../../hooks/user/myprofile';
import styled from 'styled-components';
import { useKYCStatus } from '@app/hooks/KYC/GetKYCStatus.tsx';

const IdentifyHeader = ({ level, title }) => {
  const { t } = useTranslation();
  const { data: myinfo } = useMyProfile();
  let verified = false;
  const mylevel = parseInt(myinfo?.level);
  const currentlevel = parseInt(level?.[0]?.level);
  // const {KYCStatus} = useKYCStatus()

  if (currentlevel === 1) {
    if (mylevel >= 1 || mylevel === -1) {
      verified = true;
    }
  } else if (currentlevel === 2) {
    if (mylevel >= 3) {
      verified = true;
    }
  } else if (currentlevel === 3) {
    if (mylevel >= 4) {
      verified = true;
    }
  }

  return (
    <Container>
      <Text size={16}>{t(title)}</Text>
      <View style={{ flexDirection: 'row' }}>
        <Text
          size={14}
          style={{
            marginRight: 10,
            color: verified ? COLORS.lightGreen : COLORS.lightRed,
          }}
        >
          {t(verified ? 'verified' : 'notverified')}
        </Text>
        {/*{verified ? (*/}
        {/*  <IconCircleCheck*/}
        {/*    color={verified ? COLORS.lightGreen : COLORS.lightRed}*/}
        {/*  />*/}
        {/*) : (*/}
        {/*  <IconCircleX color={verified ? COLORS.lightGreen : COLORS.lightRed} />*/}
        {/*)}*/}
      </View>
    </Container>
  );
};

export default IdentifyHeader;

const Container = styled.div`
  background-color: ${({ theme }) => theme.COLORS.PrimaryBg};
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  padding-inline: 10px;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
  display: flex;

  font-family: 'Pretendard', sans-serif;
  padding: 0 24px;
`;
